export var EDITOR_TYPE;
(function (EDITOR_TYPE) {
    EDITOR_TYPE["ADI"] = "onboarding";
    EDITOR_TYPE["Editor"] = "editor";
    EDITOR_TYPE["EditorX"] = "editor_x";
})(EDITOR_TYPE || (EDITOR_TYPE = {}));
//# sourceMappingURL=editor-type.js.map